export const individualStaffProgressPermissions = [
  "benefit-applications:create",
  "benefit-applications:edit",
  "pse-online:manage",
  "benefit-workflow:proof",
  "benefit-workflow:data",
  "admin:manage-access",
] as const

export const bulkStaffProgressPermissions = [
  "benefit-applications:create",
  "benefit-workflow:proof",
  "benefit-workflow:data",
  "admin:manage-access",
] as const

export const allStaffProgressPermissions = [
  "benefit-workflow:proof",
  "benefit-workflow:data",
  "admin:manage-access",
] as const

export function canManagePseDistribution(permissions: string[]): boolean {
  return permissions.includes("admin:manage-access") ||
    (permissions.includes("pse-online:manage") && permissions.includes("benefit-applications:assign"))
}

export function hasAnyPermission(permissions: string[], allowed: readonly string[]): boolean {
  return allowed.some((permission) => permissions.includes(permission))
}

export function canUpdateIndividualStaffProgress(permissions: string[]): boolean {
  return hasAnyPermission(permissions, individualStaffProgressPermissions)
}

export function canBulkUpdateStaffProgress(permissions: string[]): boolean {
  return hasAnyPermission(permissions, bulkStaffProgressPermissions)
}

export function canBulkUpdateAllStaffProgress(permissions: string[]): boolean {
  return hasAnyPermission(permissions, allStaffProgressPermissions)
}
